import { surveyInstance } from '..';

const fetchSurvey = async (id) => {
  const { data } = await surveyInstance.get(`/survey/${id}`);
  return data._id ? data : null;
};

export default fetchSurvey;
